import api from '../../../config/axios-interceptor';

/* ------------------------------------
 * 1) Fetch Chats (with filters + paging)
 * ------------------------------------ */
export const fetchChats = async (page = 0, pageSize = 10, filters = {}) => {
    try {
        const params = new URLSearchParams();
        params.append('page', page.toString());
        params.append('size', pageSize.toString());
        params.append('sort', 'updatedAt,desc')

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, value);
            }
        });

        return await api.get(`/api/v1/chat/find-all?${params.toString()}`);
    } catch (error) {
        console.error('❌ Error fetching chats:', error);
        throw error;
    }
};

/* ----------------------
 * 2) Fetch Chat By ID
 * ---------------------- */
export const fetchChatById = async (id) => {
    try {
        return await api.get(`/api/v1/chat/find/${id}`);
    } catch (error) {
        console.error('❌ Error fetching chat by ID:', error);
        throw error;
    }
};

/* ----------------------
 * 3) Create Chat
 * ---------------------- */
export const createChat = async (chatData) => {
    try {
        return await api.post('/api/v1/chat/create', chatData);
    } catch (error) {
        console.error('❌ Error creating chat:', error);
        throw error;
    }
};

/* ----------------------
 * 4) Update Chat
 * ---------------------- */
export const updateChat = async (chatData) => {
    try {
        return await api.put('/api/v1/chat/update', chatData);
    } catch (error) {
        console.error('❌ Error updating chat:', error);
        throw error;
    }
};

/* ----------------------
 * 5) Delete Chat
 * ---------------------- */
export const deleteChat = async (id) => {
    try {
        return await api.delete(`/api/v1/chat/delete/${id}`);
    } catch (error) {
        console.error('❌ Error deleting chat:', error);
        throw error;
    }
};